module.exports = __webpack_public_path__ + "img/pic-04.115f5944.png";